import { render, staticRenderFns } from "./GdsScore.vue?vue&type=template&id=180b6ac0&scoped=true"
import script from "./GdsScore.vue?vue&type=script&lang=js"
export * from "./GdsScore.vue?vue&type=script&lang=js"
import style0 from "./GdsScore.vue?vue&type=style&index=0&id=180b6ac0&prod&scoped=true&lang=css"
import style1 from "./GdsScore.vue?vue&type=style&index=1&id=180b6ac0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180b6ac0",
  null
  
)

export default component.exports